(function () {
    "use strict";

    angular.module("app.productDetail").factory("ProductDetailService", ProductDetailService);

    ProductDetailService.$inject = ["$http", "$q"];

    function ProductDetailService($http, $q) {
        var service = {};

        var serviceBase = "/";
        return service;
    }
})();
